import { connect } from "react-redux";
import SlideDeckModal from "../../../components/SlideDeckModal/SlideDeckModal";

const mapStateToProps = (state) => ({
  slideDeckModalOpen: state.startupflowControl.slideDeckModal,
  slideDeckSelected: state.auth.startupUser.slide_deck,
});

export default connect(mapStateToProps)(SlideDeckModal);
